import { requiredPermissionsConfig } from "../../config/config";

const getStream = async () => {
  const stream = await navigator.mediaDevices
    .getUserMedia(requiredPermissionsConfig)
    .catch(() => null);
  return Promise.resolve(stream);
};

export { getStream };
